import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';

import { useStore } from '@modules';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');
const ti = getTestId('Transactions');

export type TimeType = {
  timestamp: number;
  testId?: string;
};

export const Time: CustomFC<TimeType> = ({ timestamp, testId }) => {
  const [{ user }] = useStore();
  const language = user.data?.language_code || CONST.i18n.languages.en.code;

  return (
    <span className={cn('time')} data-testid={ti(testId)}>
      {new Date(timestamp).toLocaleTimeString(language)}
    </span>
  );
};

export default Time;
